var exports = {
  "iE": "VoiceChannelUserCount.module__wrapper___TUJKUz",
  "VV": "VoiceChannelUserCount.module__users___TUJKUz",
  "X5": "VoiceChannelUserCount.module__total___TUJKUz",
};

module.exports = exports;
